"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomIcon = void 0;

var tslib_1 = require("tslib");

var ui_flex_1 = require("@hopin-team/ui-flex");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

exports.CustomIcon = (0, styled_components_1.default)(ui_flex_1.Flex)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  width: 1rem;\n  height: 1rem;\n  background-image: ", ";\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  margin-right: 0.5rem;\n  flex-shrink: 0;\n"], ["\n  width: 1rem;\n  height: 1rem;\n  background-image: ", ";\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  margin-right: 0.5rem;\n  flex-shrink: 0;\n"])), function (_a) {
  var iconSrc = _a.iconSrc;
  return "url(".concat(iconSrc, ")");
});
var templateObject_1;